import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type AuthState = {
  token: string | null;
  isErrorMFA: boolean
};

const initialState: AuthState = { token: null, isErrorMFA: false };

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, { payload }: PayloadAction<string>) => {
      state.token = payload;
    },
    setErrorMFA: (state, { payload }: PayloadAction<boolean>) => {
      state.isErrorMFA = payload;
    },
  },
});

export const { setCredentials, setErrorMFA } = slice.actions;

export default slice.reducer;
